import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, InputAdornment, Button, CircularProgress } from '@material-ui/core';
import { FeaturedPlayListOutlined, Search } from '@material-ui/icons';
import { useGetExpedient } from '../hooks/useGetExpedient';

const FormUser = props => {

    const { setComerciante, setSnackbar } = props;

    const classes = useStyles();
    const { 
        onSubmit,
        isLoading,
        Controller,
        handleSubmit,
        errors,
        control 
    } = useGetExpedient(setComerciante, setSnackbar);

    return (
        <form className={classes.container} onSubmit={handleSubmit(onSubmit)}>
            <div className={classes.title}>Buscar registro público</div>

            <Controller 
                name='id'
                control={control}
                defaultValue=''
                render={({onChange, value}) => (
                    <TextField
                        disabled={isLoading}
                        error={ errors.id ? true : false }
                        label='Identificación'
                        helperText={ errors.id ? errors.id.message : 'Ingrese el número de cédula o NIT' }
                        fullWidth
                        size='small'
                        type='number'
                        variant="outlined"
                        style={{ marginBottom: 15 }}
                        value={value || ''}
                        onChange={onChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <FeaturedPlayListOutlined htmlColor='grey' />
                                </InputAdornment>
                            )
                        }}
                    />
                )}
                rules={{
                    required: '* Campo obligatorio',
                    pattern: {
                        value: /^[1-9][0-9]{6,9}$/,
                        message: 'La identificación no es correcta'
                    }
                }}
            />

            <Button
                variant="contained"
                startIcon={ isLoading ? <CircularProgress size={20} color='inherit' /> : <Search /> }
                fullWidth
                disabled={isLoading}
                style={{ paddingTop: 7, paddingBottom: 7, background: '#4caf50', color: '#fff' }}
                size='medium'
                type='submit'
            >
                { isLoading ? 'Buscando...' : 'Buscar' }
            </Button>
        </form>
    );
}

const useStyles = makeStyles({
    container: {
        background: '#fff',
        width: 400,
        margin: 10,
        padding: 20,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: '#CACFD2',
        borderStyle: 'solid'
    },
    title: {
        marginBottom: 25,
        fontFamily: 'Roboto',
        fontSize: 20,
        color: 'rgba(0, 0, 0, .8)',
        fontWeight: '500',
        letterSpacing: .2
    },
    divider: {
        marginBottom: 15,
        fontFamily: 'Roboto',
        color: 'grey',
        textAlign: 'center',
    }
});

export default FormUser;